import axios from 'axios'

const state = {
  partner: null,
  token: null
}

const actions = {
  LOGIN: ({ commit, dispatch }, payload) => {
    return new Promise(async (resolve, reject) => {
      let encodeString = `${payload.username}:${payload.password}`
      encodeString = btoa(encodeString)
      const config = {
        headers: {
          Authorization: `Bearer ${encodeString}`
        }
      }

      // ถ้าต้องการ OTP ก่อนเข้าสุ่ระบบ ระบบจะ generate otp ให้ และไม่ส่ง token มาให้ก่อน
      // แต่ถ้า otp มีค่า จะเป็นการส่ง otp ไปเช็คว่าตรงกันไหม
      const paramsData = {
        otp: payload.otp || null
      }
      try {
        const res = await axios.post('auth/partner-token', paramsData, config)
        const response = res.data
        if (!response.error) {
          // ถ้าเป็น partner ที่ต้องการยืนยัน otp ให้ขอ otp ก่อน แต่ถ้าเป็นการกรอก otp เข้ามาแล้วให้ข้ามส่วนนี้ไป
          if (response.need_otp && !payload.otp) {
            resolve(response)
            return
          }
          commit('SET_TOKEN', response.access_token)
          resolve(response)
        } else {
          reject(response.message)
        }
        if (payload.callback) {
          payload.callback()
        }
      } catch (err) {
        reject(err.message)
      }
    })
  },
  GET_PARTNER: ({ commit, state }, payload) => {
    return new Promise(async (resolve, reject) => {
      const errMsg = 'ผิดพลาดไม่สามารถเข้าสู่ระบบได้ กรุณาติดต่อผู้ดูแลระบบ'
      const headers = { 'Authorization': `Bearer ${state.token}` }
      try {
        const { data } = await axios.get('partners/data', { headers })
        if (!data.error && data.partner && Number(data.partner.id) === payload.partner_id) {
          commit('SET_PARTNER', data.partner)
          resolve(data.partner)
        } else {
          console.log('error GET_PARTNER', data.message)
          reject(errMsg)
        }
      } catch (err) {
        console.log('catch GET_PARTNER', err.message)
        commit('SET_TOKEN', null)
        reject(errMsg)
      }
    })
  },
  LOGOUT: async ({ commit }, payload) => {
    // const url = '/partners/logout'
    // await axios.post(url, payload.submitData)
    commit('SET_TOKEN', null)
    commit('SET_PARTNER', null)
  }
}

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_PARTNER: (state, partner) => {
    state.partner = partner
  }
}

const getters = {
  getState: state => {
    return state
  },
  getToken: state => {
    return state.token
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/auth.partner.js